import { useAuth } from '@/store/useAuth';
import { useUpdateUserData } from '@/hooks/use-update-profile';
import { generatePath, useNavigate } from 'react-router';
import { routesApp } from '@/constans/routes';
import React, { useCallback, useEffect } from 'react';
import { UploadPhotoRegistartionForm } from './components/upload-photo-registartion-form';
import 'react-toastify/dist/ReactToastify.css';
import { NameRegistartionForm } from './components/name-registartion-form';
import { DateRegistartionForm } from './components/date-registartion-form';
import {
    SettingInfoRegistrationForm
} from '@/components/form-registration-v2/components/setting-info-registartion-form';
import { TargetInfoRegistrationForm } from '@/components/form-registration-v2/components/target-info-registartion-form';
import {
    DirectionInfoRegistrationForm
} from '@/components/form-registration-v2/components/direction-info-registartion-form';
import { AboutAndTravelPlansRegistartionForm } from './components/about-and-travel-plans-registartion-form';
import { callYaMetrika } from '@/utils/call-ya-metrika';
import { eventsApi } from '@/api';
import { useTranslation } from 'react-i18next';
interface Props {
    step?: string;
    isLoadingOncePage?: boolean;
    onChangeIsLoadingPage?: (bol: boolean) => void;
}

export const FormRegistration: React.FC<Props> = ({ step, isLoadingOncePage, onChangeIsLoadingPage }) => {
    const userData = useAuth((state) => state.getUser());
    const { mutateAsync: updateUserData } = useUpdateUserData();
    const handleUpdateUserData = async (data: any) => {
        if (!userData) return;
        await updateUserData(data);
    };

    const navigateToNextStep = useNavigate();
    const nextStep = useCallback(
        (step: string) =>
            navigateToNextStep(
                generatePath(
                    routesApp.registrationV2,
                    { stepNumer: step }
                )
            ),
        [navigateToNextStep],
    );
    
    useEffect(() => {
        if (userData && isLoadingOncePage) {
            onChangeIsLoadingPage?.(false);
            // Если пользователь уже отмечен как завершенный - не душим его повторным проходом по регистрации
            // кидаем сразу в ленту
            if (userData.state === 'complete') {
                navigateToNextStep(generatePath(routesApp.browse));
                return
            }

            // Проверяем, на каком шаге нужно продолжить регистрацию
            if (!userData?.public_name) {
                nextStep('1');
                return;
            }
            if (!userData?.dob) {
                nextStep('2');
                return;
            }
            if (!userData?.photos.length) {
                nextStep('3');
                return;
            }
            if (!userData?.about_me || !userData?.travel_plans) {
                nextStep('4');
                return;
            }
            if (!userData?.gender || !userData?.looks_for) {
                nextStep('5');
                return;
            }
            if (!userData?.purpose) {
                nextStep('6');
                return;
            }
            if (!userData?.regions?.length) {
                nextStep('7');
                return;
            }
            nextStep('7');
        }
    }, []);

    const { t } = useTranslation();

    switch (step) {
        case '1':
            return (
                <NameRegistartionForm
                    userData={userData}
                    onUpdateUserData={handleUpdateUserData}
                    nextStep={() => nextStep('2')} />
            );
        case '2':
            return (
                <DateRegistartionForm
                    userData={userData}
                    onUpdateUserData={handleUpdateUserData}
                    nextStep={() => nextStep('3')} />
            );
        case '3':
            return (
                <UploadPhotoRegistartionForm userData={userData} />
            );
        case '4':
            return (
                <AboutAndTravelPlansRegistartionForm
                    userData={userData}
                    onUpdateUserData={handleUpdateUserData}
                    nextStep={() => nextStep('5')} />
            );
        case '5':
            return (
                <SettingInfoRegistrationForm
                    userData={userData}
                    onUpdateUserData={handleUpdateUserData}
                    nextStep={() => nextStep('6')} />
            );
        case '6':
            return (
                <TargetInfoRegistrationForm
                    userData={userData}
                    onUpdateUserData={handleUpdateUserData}
                    nextStep={() => nextStep('7')} />
            );
        case '7':
            return (
                <>
                    <DirectionInfoRegistrationForm
                        userData={userData}
                        onUpdateUserData={handleUpdateUserData}
                        nextStep={() => {
                            callYaMetrika('complete_registration2');
                            eventsApi.updateUserEvent('complete_registration2');
                            navigateToNextStep(routesApp.browse)
                        }}
                    />
                </>
            );
        default:
            return <>{t('registration.error404')}</>;
    }
};
